(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ms-discount-preview"] && !Shopify.designMode) return;
  try {
    // Shopify is the pricing authority. No coupon values, product lists or dates live here.
const normalCode = value => String(value || '').trim().toUpperCase();
const uniqueCodes = values => [...new Set(values.map(normalCode).filter(Boolean))];
const variantGid = id => 'gid://shopify/ProductVariant/' + String(id);
const idPattern = /^\d+$/;

function cartCodes(cart) {
  const applications = [
    ...(cart.cart_level_discount_applications || []),
    ...(cart.items || []).flatMap(item => (item.line_level_discount_allocations || []).map(a => a.discount_application))
  ].filter(Boolean);
  return uniqueCodes([
    ...(cart.discount_codes || []).map(c => c.code),
    ...applications.filter(a => a.type === 'discount_code').map(a => a.title)
  ]);
}

// The quote is for the existing basket PLUS the selected quantity. It never
// changes the real AJAX basket. Do not silently drop lines or their properties.
function makeScenario({cart, variant, quantity = 1, codes, country, customerLoggedIn = false}) {
  if (customerLoggedIn) throw new Error('buyer-identity-required');
  if (!/^[A-Z]{2}$/.test(country || '') || !Array.isArray(cart.items)) throw new Error('invalid-context');
  if (!idPattern.test(String(variant.id)) || !variant.available) throw new Error('unavailable-variant');
  if (!Number.isSafeInteger(quantity) || quantity < 1 || quantity > 250) throw new Error('invalid-quantity');
  if (cart.items.length > 40 || codes.length > 20) throw new Error('context-too-large');
  const attributes = value => Object.entries(value || {}).filter(([,v]) => v !== null && v !== '')
    .map(([key, value]) => ({key, value: String(value)}));
  const lines = cart.items.map(item => {
    if (!idPattern.test(String(item.variant_id)) || !Number.isSafeInteger(item.quantity) || item.quantity < 1)
      throw new Error('invalid-cart-line');
    if (item.item_components?.length || item.parent_relationship) throw new Error('bundle-context-required');
    const line = {merchandiseId: variantGid(item.variant_id), quantity: item.quantity};
    const props = attributes(item.properties);
    if (props.length) line.attributes = props;
    if (item.selling_plan_allocation) {
      const id = item.selling_plan_allocation.selling_plan?.id;
      if (!idPattern.test(String(id))) throw new Error('invalid-selling-plan');
      line.sellingPlanId = 'gid://shopify/SellingPlan/' + id;
    }
    return line;
  });
  const merchandiseId = variantGid(variant.id);
  const matching = lines.find(line => line.merchandiseId === merchandiseId && !line.attributes && !line.sellingPlanId);
  if (matching) matching.quantity += quantity;
  else lines.push({merchandiseId, quantity});
  const targetQuantity = matching ? matching.quantity : quantity;
  return {
    input: {lines, discountCodes: uniqueCodes(codes), buyerIdentity: {countryCode: country}, attributes: attributes(cart.attributes)},
    target: {merchandiseId, quantity: targetQuantity},
    contextual: cart.items.length > 0 || quantity > 1,
    addedQuantity: quantity
  };
}

function quoteMutation(lineCount) {
  if (!Number.isSafeInteger(lineCount) || lineCount < 1 || lineCount > 41) throw new Error('invalid-line-count');
  return `mutation MSPricePreview($input: CartInput!) {
    cartCreate(input: $input) {
      cart { totalQuantity }
      userErrors { code field message }
      warnings { code message }
      ... @defer(label: "MSFinalPrice") {
        quotedCart: cart {
          totalQuantity
          discountCodes { code applicable }
          lines(first: ${lineCount}) {
            pageInfo { hasNextPage }
            nodes {
              quantity attributes { key value }
              sellingPlanAllocation { sellingPlan { id } }
              merchandise { ... on ProductVariant { id } }
              cost { subtotalAmount { amount currencyCode } totalAmount { amount currencyCode } }
              discountAllocations(lineLevelOnly: false) {
                __typename targetType discountedAmount { amount currencyCode }
                ... on CartCodeDiscountAllocation { code }
                ... on CartAutomaticDiscountAllocation { title }
                ... on CartCustomDiscountAllocation { title }
              }
            }
          }
        }
      }
    }
  }`;
}

// Wait for the complete deferred result, including network-backed Functions.
// Never display the initial, pre-discount cart as a final price.
function decodeResponse(body, contentType) {
  let envelopes;
  if (/multipart\/mixed/i.test(contentType)) {
    const boundary = /boundary\s*=\s*(?:"([^"]+)"|([^;\s]+))/i.exec(contentType);
    if (!boundary) throw new Error('missing-boundary');
    envelopes = body.split('--' + (boundary[1] || boundary[2])).flatMap(part => {
      const separator = /\r?\n\r?\n/.exec(part);
      if (!separator) return [];
      const json = part.slice(separator.index + separator[0].length).trim();
      return json ? [JSON.parse(json)] : [];
    });
  } else envelopes = [JSON.parse(body)];
  if (!envelopes.length || envelopes.at(-1).hasNext === true) throw new Error('incomplete-response');
  let payload = null;
  for (const envelope of envelopes) {
    if (envelope.errors?.length) throw new Error('graphql-error');
    if (envelope.data?.cartCreate) payload = {...payload, ...envelope.data.cartCreate};
    const patches = envelope.incremental || (envelope.path ? [envelope] : []);
    for (const patch of patches) {
      if (patch.errors?.length) throw new Error('deferred-error');
      if (JSON.stringify(patch.path) === '["cartCreate"]') payload = {...payload, ...patch.data};
      else if (JSON.stringify(patch.path) === '["cartCreate","quotedCart"]') payload = {...payload, quotedCart: patch.data};
      else throw new Error('unexpected-patch');
    }
  }
  // Ineligible codes are an ordinary final result; product/quantity warnings are not.
  const unsafeWarnings = (payload?.warnings || []).filter(warning => !warning.code?.startsWith('DISCOUNT_'));
  if (!payload?.quotedCart || payload.userErrors?.length || unsafeWarnings.length) throw new Error('unconfirmed-quote');
  return payload.quotedCart;
}

function interpretQuote(cart, scenario, currency) {
  const expectedQuantity = scenario.input.lines.reduce((sum, line) => sum + line.quantity, 0);
  if (cart.totalQuantity !== expectedQuantity || cart.lines?.pageInfo?.hasNextPage) throw new Error('changed-basket');
  const targetLines = (cart.lines?.nodes || []).filter(line =>
    line.merchandise?.id === scenario.target.merchandiseId && !line.attributes?.length && !line.sellingPlanAllocation);
  if (targetLines.length !== 1 || targetLines[0].quantity !== scenario.target.quantity) throw new Error('changed-target');
  const line = targetLines[0];
  const money = value => {
    if (value?.currencyCode !== currency || !/^\d+(?:\.\d+)?$/.test(value?.amount || '')) throw new Error('invalid-money');
    const result = Number(value.amount);
    if (!Number.isFinite(result)) throw new Error('invalid-money');
    return result;
  };
  const originalTotal = money(line.cost.subtotalAmount);
  const lineTotal = money(line.cost.totalAmount);
  if (lineTotal < 0 || lineTotal > originalTotal) throw new Error('invalid-total');
  const allocations = (line.discountAllocations || []).filter(a => a.targetType === 'LINE_ITEM' && money(a.discountedAmount) > 0);
  // Shopify provides the exact allocation per line, including order discounts.
  // The line cost total can exclude order-level discounts; do not infer a percentage.
  const finalTotal = originalTotal - allocations.reduce((sum, allocation) => sum + money(allocation.discountedAmount), 0);
  if (finalTotal < -0.005 || finalTotal > lineTotal + 0.005) throw new Error('inconsistent-allocations');
  const codeAllocations = allocations.filter(a => a.__typename === 'CartCodeDiscountAllocation');
  const codeSet = new Set(uniqueCodes(scenario.input.discountCodes));
  if (codeAllocations.some(a => !codeSet.has(normalCode(a.code)))) throw new Error('unexpected-code');
  const confirmed = new Set((cart.discountCodes || []).filter(c => c.applicable).map(c => normalCode(c.code)));
  if (codeAllocations.some(a => !confirmed.has(normalCode(a.code)))) throw new Error('unconfirmed-code');
  // No locally reconstructed percentage, discount allocation, expiry or usage rules.
  const discounted = finalTotal < originalTotal && allocations.length > 0;
  return {
    discounted,
    originalTotal, finalTotal: Math.max(0, finalTotal), quantity: line.quantity,
    unitPrice: Math.max(0, finalTotal) / line.quantity,
    codes: uniqueCodes(codeAllocations.map(a => a.code)),
    automatic: allocations.some(a => a.__typename !== 'CartCodeDiscountAllocation'),
    contextual: scenario.contextual,
    applicable: [...confirmed]
  };
}

function collectionQuote(results) {
  if (!results.length || results.some(result => !result || result.error)) return null;
  const best = results.reduce((a,b) => a.quote.unitPrice <= b.quote.unitPrice ? a : b);
  if (!best.quote.discounted) return null;
  return {...best.quote, from: results.some(result => result.quote.unitPrice !== best.quote.unitPrice),
    partial: results.some(result => !result.quote.discounted)};
}

// Page-local deduplication only. No customer data or prices in persistent storage.
class QuoteClient {
  constructor({fetcher, endpoint = '/api/2026-10/graphql.json', concurrency = 2, ttl = 30000, clock = Date.now}) {
    this.fetcher = fetcher; this.endpoint = endpoint; this.concurrency = concurrency; this.ttl = ttl; this.clock = clock;
    this.cache = new Map(); this.queue = []; this.active = 0; this.revision = 0; this.controllers = new Set();
  }
  reset() {
    this.revision++; this.cache.clear();
    this.controllers.forEach(controller => controller.abort());
    this.queue.splice(0).forEach(job => job.reject(new Error('stale-quote')));
  }
  get(scenario, currency) {
    const key = JSON.stringify([scenario, currency]);
    const cached = this.cache.get(key);
    if (cached && cached.until > this.clock()) return cached.promise;
    const revision = this.revision;
    const promise = new Promise((resolve, reject) => {
      this.queue.push({scenario, currency, revision, resolve, reject}); this.drain();
    });
    this.cache.set(key, {promise, until: this.clock() + this.ttl});
    promise.catch(() => { if (this.cache.get(key)?.promise === promise) this.cache.delete(key); });
    return promise;
  }
  drain() {
    while (this.active < this.concurrency && this.queue.length) {
      const job = this.queue.shift();
      this.active++;
      this.run(job).then(job.resolve, job.reject).finally(() => { this.active--; this.drain(); });
    }
  }
  async run({scenario, currency, revision}) {
    if (revision !== this.revision) throw new Error('stale-quote');
    const controller = new AbortController(); this.controllers.add(controller);
    const timeout = setTimeout(() => controller.abort(), 12000);
    try {
      const query = quoteMutation(scenario.input.lines.length);
      const variables = {input: scenario.input};
      const response = await this.fetcher(this.endpoint, {
        method: 'POST', credentials: 'omit', cache: 'no-store', signal: controller.signal,
        headers: {'Content-Type': 'application/json', Accept: 'multipart/mixed; deferSpec=20220824, application/json'},
        body: JSON.stringify({query, variables})
      });
      if (!response.ok) throw new Error('quote-unavailable: HTTP ' + response.status);
      const body = await response.text();
      if (revision !== this.revision) throw new Error('stale-quote');
      return interpretQuote(decodeResponse(body, response.headers.get('content-type') || ''), scenario, currency);
    } finally { clearTimeout(timeout); this.controllers.delete(controller); }
  }
}

// v2: generic, on-demand Shopify quotes; no campaign metafield or known-code list.
if (!customElements.get('ms-discount-preview')) {
  const storageKey = 'meersuechtig.discount-selection.v2';
  const elements = new Set();
  const client = new QuoteClient({fetcher: (...args) => fetch(...args)});
  const params = new URLSearchParams(location.search);
  let saved = {};
  try { saved = JSON.parse(sessionStorage.getItem(storageKey) || '{}'); } catch (_) {}
  let nativeCode = '';
  try {
    const cookie = document.cookie.split(';').map(value => value.trim()).find(value => value.startsWith('discount_code='));
    if (cookie) nativeCode = decodeURIComponent(cookie.slice('discount_code='.length));
  } catch (_) {}
  let codes = params.has('discount') ? uniqueCodes(params.get('discount').split(','))
    : (saved.dismissed ? [] : uniqueCodes(saved.codes || (nativeCode ? [nativeCode] : [])));
  let explicitSelection = params.has('discount') || (!saved.dismissed && saved.explicitSelection === true);
  let confirmed = !explicitSelection && saved.confirmed === true;
  let dismissed = !params.has('discount') && saved.dismissed === true;
  let cart = null;
  let revision = 0;
  let debounce;
  let cartRead;
  const remember = () => {
    try { sessionStorage.setItem(storageKey, JSON.stringify({codes, dismissed, confirmed, explicitSelection})); } catch (_) {}
  };
  function hideAll() { elements.forEach(element => element.clear()); }
  function visible(element) {
    if (element.parentElement?.closest?.('[hidden],[inert],[aria-hidden="true"]')) return false;
    if (element.parentElement?.checkVisibility && !element.parentElement.checkVisibility({visibilityProperty:true})) return false;
    const box = element.parentElement?.getBoundingClientRect();
    return box && box.height > 0 && box.top < innerHeight + 150 && box.bottom > -150
      && (box.right === undefined || box.right > 0) && (box.left === undefined || box.left < innerWidth);
  }
  function renderVisible() { elements.forEach(element => { if (visible(element)) element.render(); }); }
  function invalidate() {
    revision++; client.reset(); hideAll();
  }
  async function refreshCart(reason = 'refresh') {
    invalidate();
    const run = revision;
    cart = null;
    cartRead?.abort(); cartRead = new AbortController();
    const readController = cartRead;
    const timeout = setTimeout(() => readController.abort(), 10000);
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart.js', {credentials: 'same-origin', cache: 'no-store', signal: readController.signal});
      if (!response.ok) throw new Error('cart-unavailable');
      const next = await response.json();
      if (run !== revision || !Array.isArray(next.items)) return;
      const detected = cartCodes(next);
      if (reason === 'write') explicitSelection = false;
      if (explicitSelection) {
        confirmed = codes.length > 0 && codes.every(code => detected.includes(code));
      } else if (detected.length) {
        codes = detected; confirmed = true; dismissed = false;
      } else if (confirmed || reason === 'write') {
        codes = []; confirmed = false; dismissed = true;
      }
      cart = next; remember(); renderVisible();
    } catch (_) { if (run === revision) hideAll(); }
    finally { clearTimeout(timeout); }
  }
  function schedule(reason = 'refresh') {
    // Withdraw old quotes immediately, before the network response arrives.
    invalidate(); cart = null;
    clearTimeout(debounce); debounce = setTimeout(() => refreshCart(reason), 150);
  }
  function selectedVariant(element) {
    const product = element.product;
    if (!product.selectedVariantId) return null;
    const urlVariant = new URLSearchParams(location.search).get('variant');
    return product.variants.find(v => v.id === urlVariant) || product.variants.find(v => v.id === product.selectedVariantId);
  }
  function selectedQuantity(variant) {
    const forms = [...document.querySelectorAll('form[action*="/cart/add"]')];
    const form = forms.find(form => String(form.elements.namedItem('id')?.value || '') === variant.id);
    const value = form?.elements.namedItem('quantity')?.value;
    return value === undefined ? 1 : Number(value);
  }
  class DiscountPreview extends HTMLElement {
    connectedCallback() {
      this.output = this.querySelector('[data-ms-output]'); this.hidden = true;
      try { this.product = JSON.parse(this.dataset.product); }
      catch (_) { return; }
      if (!this.output || !Array.isArray(this.product.variants)) return;
      elements.add(this);
      if (!cart) schedule(); else if (visible(this)) this.render();
    }
    disconnectedCallback() { elements.delete(this); this.ticket = null; }
    clear() { this.ticket = null; this.hidden = true; delete this.dataset.quoteError; this.output?.replaceChildren(); }
    message(text) {
      if (!this.product.selectedVariantId || !codes.length) return;
      const detail = document.createElement('small'); detail.textContent = text;
      this.output.replaceChildren(detail); this.hidden = false;
    }
    async render() {
      if (!cart || cart.currency !== this.dataset.currency || !codes.length) { this.clear(); return; }
      const variant = selectedVariant(this);
      const quantity = variant ? selectedQuantity(variant) : 1;
      const signature = JSON.stringify([revision, variant?.id, quantity]);
      if (this.signature === signature && this.ticket) return;
      this.signature = signature; this.clear();
      const ticket = {}; this.ticket = ticket;
      const variants = variant ? [variant] : this.product.variants.filter(v => v.available);
      // Do not pretend an anonymous Storefront cart carries a logged-in buyer,
      // custom product properties, subscriptions or transformed bundle context.
      if (this.dataset.customerLoggedIn === 'true' || this.product.bundle || this.product.sellingPlan) {
        this.message('Dein persönlicher Rabatt wird im Warenkorb geprüft.'); return;
      }
      if (!variants.length || variants.length > 50) {
        this.message('Wähle eine Variante, um den Rabatt zu prüfen.'); return;
      }
      try {
        const results = await Promise.all(variants.map(async currentVariant => {
          const scenario = makeScenario({cart, variant: currentVariant, quantity, codes, country: this.dataset.country});
          const quote = await client.get(scenario, this.dataset.currency);
          // Reject a channel/market price that disagrees with the Liquid product price.
          if (Math.abs(quote.originalTotal / quote.quantity - currentVariant.price / 100) > 0.005)
            throw new Error('catalogue-price-mismatch');
          return {variant: currentVariant, quote};
        }));
        if (this.ticket !== ticket || !this.isConnected) return;
        const quote = variant ? results[0].quote : collectionQuote(results);
        if (!quote?.discounted) {
          this.clear(); return;
        }
        const format = new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {style:'currency', currency:this.dataset.currency});
        const price = document.createElement('strong'); price.className = 'ms-discount-preview__price';
        const label = quote.codes.length ? ' mit ' + quote.codes.join(' + ') + (quote.automatic ? ' und weiteren Rabatten' : '') : ' mit Rabatt';
        price.textContent = (quote.from ? 'Ab ' : '') + (quote.quantity > 1 ? 'Ø ' : '') + format.format(quote.unitPrice) + label;
        const detail = document.createElement('small');
        detail.textContent = quote.contextual
          ? 'Beim Hinzufügen zum aktuellen Warenkorb' + (quote.quantity > 1 ? ' · ' + quote.quantity + ' Stück zusammen: ' + format.format(quote.finalTotal) : '')
          : 'Für 1 Stück · regulär ' + format.format(quote.originalTotal);
        if (quote.partial) detail.textContent += ' · ausgewählte Varianten';
        this.output.replaceChildren(price, detail); this.hidden = false;
        if (!confirmed && codes.length === 1) {
          const apply = document.createElement('a');
          const redirect = new URL(location.href); redirect.searchParams.delete('discount');
          apply.href = (window.Shopify?.routes?.root || '/') + 'discount/' + encodeURIComponent(codes[0])
            + '?redirect=' + encodeURIComponent(redirect.pathname + redirect.search + redirect.hash);
          apply.textContent = 'Code anwenden'; this.output.append(apply);
        }
      } catch (error) {
        if (this.ticket === ticket) {
          this.dataset.quoteError = error.message;
          this.message('Dein Rabatt wird im Warenkorb geprüft.');
        }
      }
    }
  }
  customElements.define('ms-discount-preview', DiscountPreview);
  ['pageshow','focus'].forEach(name => addEventListener(name, () => schedule()));
  document.addEventListener('visibilitychange', () => { if (!document.hidden) schedule(); else invalidate(); });
  ['cart:updated','cart:refresh','cart:change','cart:update','shopify:cart:discount-update','shopify:cart:line-add','shopify:cart:line-update','shopify:cart:line-remove']
    .forEach(name => document.addEventListener(name, () => schedule('write')));
  ['variant:change','variant-change','product:variant-change'].forEach(name => document.addEventListener(name, () => schedule()));
  document.addEventListener('change', event => {
    if (event.target.matches?.('input[name="quantity"],select[name="quantity"],input[name="id"],select[name="id"],input[type="radio"],select[name^="options"]')) schedule();
  });
  document.addEventListener('submit', event => { if (event.target.matches?.('form[action*="/cart/add"]')) invalidate(); });
  let scrollTimer;
  addEventListener('scroll', () => { clearTimeout(scrollTimer); scrollTimer = setTimeout(renderVisible, 120); }, {passive:true});
  // Code changes and expiry are checked again while the page stays open.
  setInterval(() => { if (!document.hidden && codes.length) schedule(); }, 60000);
  if ('PerformanceObserver' in window) {
    try {
      new PerformanceObserver(list => {
        if (list.getEntries().some(entry => {
          const url = new URL(entry.name, location.href);
          return url.origin === location.origin && /\/cart\/(add|update|change|clear)(\.js)?\/?$/.test(url.pathname);
        })) schedule('write');
      }).observe({type:'resource', buffered:false});
    } catch (_) {}
  }
}
  } catch(e) { console.error(e); }
})();

})();
